module.exports = __webpack_public_path__ + "site/img/vedio.b8f7ffe.gif";


//////////////////
// WEBPACK FOOTER
// ./site/vedio.gif
// module id = 155
// module chunks = 1